import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import DynamicIcon from "../../dynamicIcon/dynamicIcon";
import { TabsStyle, TanContent } from "./tabs.style";
import FormGenerator from "../../../plugins/formGenerator/form";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <TanContent
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </TanContent>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MuiTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabsStyle
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
          textColor="inherit"
        >
          <Tab
            label="Drivers"
            {...a11yProps(0)}
            icon={<DynamicIcon iconName={"fa/FaTruck"} size={60} color="red" />}
            iconPosition="top"
          />
          <Tab
            label="Trips"
            {...a11yProps(1)}
            icon={
              <DynamicIcon
                iconName={"tb/TbArrowRoundaboutRight"}
                size={60}
                color="red"
              />
            }
            iconPosition="top"
          />
          <Tab
            label="Fuel Expenses"
            {...a11yProps(2)}
            icon={
              <DynamicIcon
                iconName={"md/MdOutlineWallet"}
                size={60}
                color="red"
              />
            }
            iconPosition="top"
          />
          <Tab
            label="Driver Bills"
            {...a11yProps(3)}
            icon={
              <DynamicIcon
                iconName={"fa/FaMoneyBillWave"}
                size={60}
                color="red"
              />
            }
            iconPosition="top"
          />
          <Tab
            label="Salaries"
            {...a11yProps(4)}
            icon={
              <DynamicIcon iconName={"tb/TbPigMoney"} size={60} color="red" />
            }
            iconPosition="top"
          />
        </TabsStyle>
      </Box>
      <CustomTabPanel value={value} index={0}>
        Under Constructon
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div>
          <FormGenerator
            formId="trips"
            formIntData={{
              formHide: true,
            }}
          />
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <div>
          <FormGenerator
            formId="fuel_expenses"
            formIntData={{
              formHide: true,
            }}
          />
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <div>
          <FormGenerator
            formId="driver_bills"
            formIntData={{
              formHide: true,
            }}
          />
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        Under Constructon
      </CustomTabPanel>
    </Box>
  );
}
